import { BoxProps } from '@chakra-ui/react';
import React from 'react';

import { CmBox } from '..';

export const CmCard: React.FC<BoxProps> = ({
  bg = 'white',
  padding = '4',
  rounded = 'md',
  children,
  ...rest
}) => {
  return (
    <CmBox
      display="flex"
      alignContent="center"
      flexDirection="column"
      borderWidth="1px"
      borderColor="gray.400"
      {...{ bg, padding, rounded, ...rest }}
    >
      {children}
    </CmBox>
  );
};
